import { render, staticRenderFns } from "./intransfer_stock.vue?vue&type=template&id=672aa9a2"
import script from "./intransfer_stock.vue?vue&type=script&lang=js"
export * from "./intransfer_stock.vue?vue&type=script&lang=js"
import style0 from "./intransfer_stock.vue?vue&type=style&index=0&id=672aa9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports